/**
 * Donate
 **/
app.add({
    onLoad: function(){

        $(document).delegate('.donation-button', 'click', function(event) {
            var $form = $(this).parents('form'),
                $input = $form.find('[name="amount"]'),
                value = $input.val();

            if (value) {
              // $form.submit();
            }
        });

        $('[type="text"][name="amount"]').click(function(){
            $(this).parents('.donation-button').trigger('click');
        });

        let $downloadForm = $('form#download_trigger');

        if ($downloadForm.length) {
            $('.poster-modal-guard').click(function(e){
                e.preventDefault();
                var href = $(this).attr('data-href');
                $downloadForm.find('#download_url').val(href);
                $(this).parents('.donation-confirm').trigger('click');
                $('#selected_poster').val($(this).attr('data-poster'));
                return false;
            });
        }

        if ($('.automatic-download').length) {
          $('.poster-modal-guard').click(function(e){
              e.preventDefault();
              var href = $(this).attr('data-href');
              downloadFile(href);
              return false;
          });
        }

        var downloadFile = function(urlToSend, callback) {
            var req = new XMLHttpRequest();
            req.open("GET", urlToSend, true);
            req.responseType = "blob";
            req.onload = function (event) {
                let blob = req.response;
                let fileName = urlToSend.split('/').pop();
                let link = document.getElementById('file_download');
                link.href = window.URL.createObjectURL(blob);
                if (fileName) {
                    link.download = fileName;
                }

                link.click();
                ga('send', 'event', 'Poster', 'poster-download');

                if (callback) {
                    callback();
                }
            };
            req.send();
        };

        $('.continue-button').click(function(e){
            var triggerForm = false;
            var closeModal = false;
            var triggerDownload = false;

            var selection = $('[name="amount_selection"]:checked').val();

            if (selection == 'zero') {
                closeModal = true;
                triggerDownload = true;
            } else {
                if (selection == 'one') {
                    triggerDownload = false;
                    triggerForm = true;
                } else {
                    triggerDownload = false;
                    triggerForm = !! $('#custom_amount').val();
                }
            }

            var restOfCallbacks = function () {
                if (closeModal) {
                    $('.donation-modal').modal('hide');
                }

                if (triggerForm) {
                    ga('send', 'event', 'Donation', 'donation');
                    $('#donation-form').submit();
                }
            };

            if (triggerDownload) {
                downloadFile($('#download_url').val(), restOfCallbacks);
            } else {
                restOfCallbacks();
            }

            e.preventDefault();
            return false;
        });
    },
});












// WEBPACK FOOTER //
// ./resources/assets/js/modules/donate.js